module.exports = __webpack_public_path__ + "img/twig_one_ex.3f6b6f90.png";